import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import template from './template.html';
import logger from '../../../shared/logger';
import { INSIGHT_TAB } from '../../position/insight/component';
import {
    SCRAPE_REQUEST_TEMPLATE_NAME,
    SCRAPE_TEMPLATES_NAME,
    COMPLETE_JOB_DEFINITION_TEMPLATES_NAME,
} from '../../employer/employerJob/employerJobController';
import './style.scss';
import { POSITION_EVENT_FLOW_TYPES } from '../../../constants/positionEvents';
import { Recruiter } from '../../core/route/recruiterService';

String.prototype.replaceAll = function (search, replacement) {
    const target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

export class RecruiterOpenJobController {
    actions = {
        CLONE_JOB: () => this.cloneJob(),
        REQUEST_SCRAPE: () => this.initScrapeRequest(),
        REQUEST_SCRAPE_AGAIN: () => this.initScrapeRequest(),
        GENERATE_INSIGHT: () => this.generateInsights(),
        SEND_INSIGHT_REPORT: () => this.initInsightToEmployer(),
        RE_SEND_INSIGHT_REPORT: () => this.initInsightToEmployer(),
        UN_CLAIM: () => this.unClaimJob(),
        CLAIM: () => this.claimJob(),
        COMPLETE_JOB_DEFINITION: () => this.initCompleteJobDefinition(),
    };

    /* @ngInject */
    constructor(
        $scope,
        $compile,
        $stateParams,
        PositionService,
        RecruiterService,
        CommonCodeService,
        $state,
        $timeout,
        RouteService,
        EmployerService,
        NotificationService,
        WorkflowService,
        utils,
        TalentService,
        $filter,
        $localStorage,
        TalentScoreService,
        EnvSettings,
        permissions,
        MessageService,
        RecruiterWorkflowStepResolver,
        PositionEventsService,
        PositionReportService,
        ImpersonationService,
        EmailService,
        DOMAIN_CONFIG,
        EMPLOYER_REP_AUTH_FLOW,
        EMPLOYER_WORKFLOW_STATUS,
        clipboard,
        WebAppRouteService,
    ) {
        const recruiterOpenJobCtrl = this;

        this.$state = $state;
        this.$scope = $scope;
        this.$filter = $filter;
        this.clipboard = clipboard;
        this.$scope.EMPLOYER_WORKFLOW_STATUS = EMPLOYER_WORKFLOW_STATUS;
        this.$stateParams = $stateParams;
        this.positionEventsService = PositionEventsService;
        this.positionService = PositionService;
        this.positionReportService = PositionReportService;
        this.notificationService = NotificationService;
        this.employerService = EmployerService;
        this.RecruiterWorkflowStepResolver = RecruiterWorkflowStepResolver;
        this.routeService = RouteService;
        this.emailService = EmailService;
        this.messageService = MessageService;
        this.EMPLOYER_REP_AUTH_FLOW = EMPLOYER_REP_AUTH_FLOW;
        this.EnvSettings = EnvSettings;
        this.positionEventService = PositionEventsService;
        this.recruiterService = RecruiterService;
        this.NotificationService = NotificationService;
        this.EMPLOYER_WORKFLOW_STATUS = EMPLOYER_WORKFLOW_STATUS;
        this.WebAppRouteService = WebAppRouteService;
        this.CommonCodeService = CommonCodeService;

        this.startLoading = () => $timeout(() => { this.loading = true; });
        this.stopLoading = () => $timeout(() => { this.loading = false; });
        this.handleSelectedTab();

        recruiterOpenJobCtrl.$onInit = async () => {
            const { positionId } = $stateParams;
            recruiterOpenJobCtrl.positionId = positionId;
            recruiterOpenJobCtrl.asideForm = 'default';

            recruiterOpenJobCtrl.startLoading();

            const { result: positionData } = await PositionService.getPosition(positionId);
            this.positionData = positionData;
            recruiterOpenJobCtrl.insightBlocks = await PositionService.getPositionReports($stateParams.positionId);
            recruiterOpenJobCtrl.updateMenuButtonsState(recruiterOpenJobCtrl.recruiterPosition);
            recruiterOpenJobCtrl.summernoteOptions = {
                defaultFontName: 'Arial',
                toolbar: [
                    ['style', ['bold', 'italic', 'underline']],
                    ['alignment', ['ul']],
                    ['insert', ['ltr', 'rtl']],
                ],
                callbacks: {
                    onInit(summernote) {
                        summernote.toolbar.hide();
                        const $win = $(window); // or $box parent container
                        const $noteEditor = $('.note-editor');
                        $win.on('click.Bst', (event) => {
                            if ($noteEditor.has(event.target).length === 0 && !$noteEditor.is(event.target)) {
                                summernote.toolbar.hide();
                            }
                        });
                        summernote.editable.focus(() => {
                            summernote.toolbar.show();
                        });
                    },
                },
            };
            recruiterOpenJobCtrl.criteriaFields = RouteService.getSystemPreference('searchCriteriaFields');
            EmployerService.getEmployer(recruiterOpenJobCtrl.positionData.employerId)
                .then((response) => {
                    recruiterOpenJobCtrl.positionData.employerData = response.result;
                    recruiterOpenJobCtrl.stopLoading();
                })
                .catch(err => logger.error(err));

            recruiterOpenJobCtrl.positionData.locationData = this.CommonCodeService.getLocationData(recruiterOpenJobCtrl.positionData);
            for (let i = 0; i < recruiterOpenJobCtrl.criteriaFields.length; i++) {
                if (recruiterOpenJobCtrl.criteriaFields[i].type === 'minMaxStatic') {
                    const minIndex = _.findIndex(recruiterOpenJobCtrl.positionData.desiredCandidateProfile.selected, {
                        field: recruiterOpenJobCtrl.criteriaFields[i].minField,
                    });
                    const maxIndex = _.findIndex(recruiterOpenJobCtrl.positionData.desiredCandidateProfile.selected, {
                        field: recruiterOpenJobCtrl.criteriaFields[i].maxField,
                    });
                    if (minIndex >= 0 || maxIndex >= 0) {
                        recruiterOpenJobCtrl.criteriaFields[i].check = true;
                        if (minIndex >= 0) {
                            recruiterOpenJobCtrl.criteriaFields[i].minSelected =
                                recruiterOpenJobCtrl.positionData.desiredCandidateProfile.selected[minIndex].items;
                        }
                        if (maxIndex >= 0) {
                            recruiterOpenJobCtrl.criteriaFields[i].maxSelected =
                                recruiterOpenJobCtrl.positionData.desiredCandidateProfile.selected[maxIndex].items;
                        }
                    } else {
                        recruiterOpenJobCtrl.criteriaFields[i].check = false;
                    }
                } else {
                    const index = _.findIndex(recruiterOpenJobCtrl.positionData.desiredCandidateProfile.selected, {
                        field: recruiterOpenJobCtrl.criteriaFields[i].field,
                    });
                    if (index >= 0) {
                        recruiterOpenJobCtrl.criteriaFields[i].check = true;
                        recruiterOpenJobCtrl.criteriaFields[i].selected =
                            recruiterOpenJobCtrl.positionData.desiredCandidateProfile.selected[index].items;
                    } else {
                        recruiterOpenJobCtrl.criteriaFields[i].check = false;
                    }
                }
            }
        };

        recruiterOpenJobCtrl.init = async function () {
            recruiterOpenJobCtrl.jobCliamed = false;
            recruiterOpenJobCtrl.cloneJobData = {};
            recruiterOpenJobCtrl.talenyaUser = false;
            recruiterOpenJobCtrl.firstCancelled = true;
            recruiterOpenJobCtrl.recruiterPosition = _.find(recruiterOpenJobCtrl.recruiterCtrl.recruiterData.positions, {
                positionId: $stateParams.positionId,
            });

            if (recruiterOpenJobCtrl.recruiterPosition) {
                recruiterOpenJobCtrl.jobCliamed = true;
            }

            recruiterOpenJobCtrl.talenyaUser = permissions.isTalenyaUser();
            recruiterOpenJobCtrl.updateMenuButtonsState(recruiterOpenJobCtrl.recruiterPosition);
        };

        recruiterOpenJobCtrl.hidePosition = function () {
            RecruiterService.hideRecruiterPosition(recruiterOpenJobCtrl.recruiterCtrl.recruiterData._id, recruiterOpenJobCtrl.positionId)
                .then(() => {
                    $state.go('recruiter.positions', {}, { reload: true });
                })
                .catch(err => logger.error(err));
        };

        recruiterOpenJobCtrl.showPosition = function () {
            RecruiterService.unhideRecruiterPosition(recruiterOpenJobCtrl.recruiterCtrl.recruiterData._id, recruiterOpenJobCtrl.positionId)
                .then(() => {
                    $state.go('recruiter.positions', {}, { reload: true });
                })
                .catch(err => logger.error(err));
        };

        recruiterOpenJobCtrl.claimJob = () => {
            const notHaveRemainPositions = !recruiterOpenJobCtrl.recruiterCtrl.recruiterData.remainingPositions > 0;
            const notHaveRemainRecruiters = !recruiterOpenJobCtrl.positionData.remainingRecruiters > 0;

            if (notHaveRemainPositions) {
                NotificationService.error('You have reached the maximum number of claimed positions');

                return;
            }

            if (notHaveRemainRecruiters) {
                NotificationService.error('Position has reached the maximum number of Talent Experts');

                return;
            }

            const recruiterId = recruiterOpenJobCtrl.recruiterCtrl.recruiterData._id;
            recruiterOpenJobCtrl.loading = true;

            RecruiterService.claimAndGetPosition(recruiterId, recruiterOpenJobCtrl.positionId)
                .then(({ result: position }) => recruiterOpenJobCtrl.updateMenuButtonsState(position))
                .then(() => {
                    recruiterOpenJobCtrl.jobCliamed = true;
                    recruiterOpenJobCtrl.loading = false;
                    NotificationService.success($filter('translate')('CLAIMED_JOB_SUCCESS'));
                })
                .catch(err => logger.error(err));
        };

        recruiterOpenJobCtrl.openEditJob = function () {
            $state.go('recruiter.editJob', {
                positionId: recruiterOpenJobCtrl.positionId,
                employerId: recruiterOpenJobCtrl.positionData.employerId,
            });
        };

        recruiterOpenJobCtrl.unClaimJob = function () {
            RecruiterService.unClaimJob(
                recruiterOpenJobCtrl.recruiterCtrl.recruiterData._id,
                recruiterOpenJobCtrl.positionId,
            )
                .then(() => {
                    $state.go('recruiter.positions', {}, { reload: true });
                })
                .catch(err => logger.error(err));
        };

        recruiterOpenJobCtrl.openCandidateWorkflowEmpView = function (workflow) {
            const employerId = recruiterOpenJobCtrl.positionData.employerId;
            const positionId = recruiterOpenJobCtrl.positionId;
            let workflowStep = workflow.employerStatus.current;

            if (workflowStep === EMPLOYER_WORKFLOW_STATUS.NONE) {
                workflowStep = EMPLOYER_WORKFLOW_STATUS.CONTACT;
            }

            return this.WebAppRouteService.goToEmployerCandidatesPage({
                employerId,
                positionId,
                workflowStep,
            });
        };

        recruiterOpenJobCtrl.openCandidateWorkflow = function (workflow) {
            $state.go('recruiter.candidatesJob', {
                positionId: recruiterOpenJobCtrl.positionId,
                scroll: 0,
                currCandidatePage: 1,
                talentID: null,
                workflowStep: workflow.recruiterStatus.current,
            }, { reload: true });
        };

        recruiterOpenJobCtrl.openCandidateWorkflowCandidate = function (workflow) {
            if (workflow.recruiterId !== $stateParams.recruiterId) {
                return;
            }
            $state.go('recruiter.candidatesJob', {
                positionId: recruiterOpenJobCtrl.positionId,
                scroll: 0,
                currCandidatePage: 1,
                talentID: workflow.talentId,
                workflowStep: workflow.recruiterStatus.current,
            }, { reload: true });
        };

        recruiterOpenJobCtrl.updatePosition = function () {
            PositionService.addPosition(recruiterOpenJobCtrl.positionData, true);
        };

        recruiterOpenJobCtrl.createUpdateEmployer = function () {
            EmployerService.putEmployer(recruiterOpenJobCtrl.positionData.employerData._id, {
                internalNote: recruiterOpenJobCtrl.positionData.employerData.internalNote,
            }, true)
                .then(() => {
                    recruiterOpenJobCtrl.editableTINotes = false;
                })
                .catch(err => logger.error(err));
        };

        recruiterOpenJobCtrl.initTalentExpert = function () {
            if (recruiterOpenJobCtrl.talentExpertTabLoading) {
                return;
            }
            recruiterOpenJobCtrl.talentExpertTabLoading = true;
            WorkflowService.getWorkflowSearch({
                positionId: recruiterOpenJobCtrl.positionId,
                employerId: recruiterOpenJobCtrl.positionData.employerId,
            })
                .then((response) => {
                    let positionWorkflows = recruiterOpenJobCtrl.positionData.workflowData;
                    let recruitersWithNoWorkflows = recruiterOpenJobCtrl.positionData.recruitersWithNoWorkflows || [];
                    positionWorkflows = _.remove(response.result, workflow => (workflow.recruiterStatus.current !== 'Hidden'
                        && workflow.recruiterStatus.current !== 'Prospect'));

                    const talents = {
                        talentIDs: _.map(positionWorkflows, 'talentId'),
                    };
                    let positionRecruiters = recruiterOpenJobCtrl.positionData.recruiters;
                    if (positionRecruiters.length > 0) {
                        RecruiterService.postRecruiterSearch({ recruiterIDs: positionRecruiters })
                            .then((response) => {
                                positionRecruiters = response.result;

                                recruitersWithNoWorkflows = angular.copy(response.result);
                                for (let i = 0; i < positionWorkflows.length; i++) {
                                    const recruiter = _.find(positionRecruiters, { _id: positionWorkflows[i].recruiterId });
                                    if (recruiter) {
                                        positionWorkflows[i].recruiterData = recruiter;
                                    }
                                    talents.talentIDs.push(positionWorkflows[i].talentId);
                                    _.remove(recruitersWithNoWorkflows, { _id: positionWorkflows[i].recruiterId });
                                }
                            })
                            .catch(err => logger.error(err));
                    } else {
                        positionRecruiters = [];
                        recruitersWithNoWorkflows = [];
                    }

                    const maxCandidatesPerRecruiter = 200;
                    const positionWorfklowsCount = positionWorkflows.length;
                    const positionRecruitersCount = positionRecruiters.length;
                    const recruitersWithNoWorkflowsCount = recruitersWithNoWorkflows.length;
                    recruiterOpenJobCtrl.hasMoreRecords = false;
                    let avgCandidateCount = 1;
                    const candidatestPerRecruiter = {};

                    if ((positionWorfklowsCount + recruitersWithNoWorkflowsCount) > maxCandidatesPerRecruiter) {
                        recruiterOpenJobCtrl.hasMoreRecords = true;
                        avgCandidateCount = maxCandidatesPerRecruiter / positionRecruitersCount;
                        for (let i = 0; i < positionRecruitersCount; i++) {
                            const recruiterId = positionRecruiters[i];
                            candidatestPerRecruiter[recruiterId] = 0;
                        }
                    }

                    if (talents.talentIDs.length > 0) {
                        TalentService.postTalents(talents)
                            .then((response) => {
                                for (let i = 0; i < response.result.length; i++) {
                                    const workflow = _.find(positionWorkflows, { talentId: response.result[i].talentId });
                                    if (workflow) {
                                        workflow.talent = response.result[i];
                                    }

                                    if (recruiterOpenJobCtrl.hasMoreRecords) {
                                        if (candidatestPerRecruiter[workflow.recruiterId] < avgCandidateCount) {
                                            candidatestPerRecruiter[workflow.recruiterId] += 1;
                                        } else {
                                            _.remove(positionWorkflows, { _id: workflow._id });
                                        }
                                    }
                                }

                                recruiterOpenJobCtrl.positionData.workflowData = positionWorkflows;
                                recruiterOpenJobCtrl.talentExpertTabLoading = false;
                            })
                            .catch(err => logger.error(err));
                    } else {
                        recruiterOpenJobCtrl.talentExpertTabLoading = false;
                    }
                })
                .catch(err => logger.error(err));
        };

        recruiterOpenJobCtrl.initInsightData = () => recruiterOpenJobCtrl.tabDisplay = 8;

        recruiterOpenJobCtrl.initInsightToEmployer = function () {
            if (recruiterOpenJobCtrl.insightBlocks) {
                const language = RouteService.getUserPreference('uiLanguage') || 'en-US';

                RouteService.getEmailTemplates(language, 'insightTemplates')
                    .then((response) => {
                        recruiterOpenJobCtrl.contactUserTemplates = [];
                        recruiterOpenJobCtrl.userData = {
                            positionData: recruiterOpenJobCtrl.positionData,
                            emailType: 'employer',
                        };
                        recruiterOpenJobCtrl.asideForm = 'sendInsight';
                        if (response.result && response.result.templates) {
                            recruiterOpenJobCtrl.contactUserTemplates = EmailService.changeTemplateTags(
                                response.result.templates,
                                recruiterOpenJobCtrl.positionData,
                                recruiterOpenJobCtrl.recruiterCtrl.recruiterData,
                                recruiterOpenJobCtrl.positionData.employerData,
                            );
                        }
                    })
                    .catch(err => logger.error(err));
            } else {
                NotificationService.error('THERE IS NO INSIGHT REPORT YET');
            }
        };

        recruiterOpenJobCtrl.sendInsightToEmployer = async function (type, contactData) {
            recruiterOpenJobCtrl.loading = true;
            const subject = EmailService.cleanUpSpecificHTMLTags(contactData.subject);

            if (contactData.email && contactData.email.length > 0) {
                const recruiterEmail = Recruiter.getEmail(recruiterOpenJobCtrl.recruiterCtrl.recruiterData);
                let recruiterPhone = '';
                if (recruiterOpenJobCtrl.recruiterCtrl.recruiterData.contact.phone.length > 0) {
                    recruiterPhone = recruiterOpenJobCtrl.recruiterCtrl.recruiterData.contact.phone[0].value;
                }

                const messageEmailContent = {
                    subject,
                    body: contactData.content,
                    destinations: [],
                    source: {
                        recruiterId: recruiterOpenJobCtrl.recruiterCtrl.recruiterData._id,
                    },
                    messageContext: {
                        positionId: recruiterOpenJobCtrl.positionData._id,
                    },
                };

                RouteService.sendContactCandidateMail({
                    from: 'talentExperts',
                    body: contactData.content,
                    to: contactData.email,
                    subject,
                    talentExpertName: recruiterOpenJobCtrl.recruiterCtrl.recruiterData.fullName,
                    talentExpertEmail: recruiterEmail,
                    talentExpertCellPhone: recruiterPhone,
                })
                    .then(() => {
                        recruiterOpenJobCtrl.asideForm = 'default';
                        Promise.all([
                            recruiterOpenJobCtrl.positionEventsService.insightSent(
                                recruiterOpenJobCtrl.positionData,
                                recruiterOpenJobCtrl.recruiterCtrl.recruiterData,
                            ),
                            MessageService.addMessage(messageEmailContent),
                        ])
                            .then(() => {
                                recruiterOpenJobCtrl.notificationService.success('INSIGHT_REPORT_SENT_SUCCESS');
                                recruiterOpenJobCtrl.$state.go('recruiter.openPosition', { positionId: recruiterOpenJobCtrl.positionData._id }, { reload: true });
                            })
                            .catch((err) => {
                                logger.error(err);
                                recruiterOpenJobCtrl.loading = false;
                                recruiterOpenJobCtrl.notificationService.error('INSIGHT_REPORT_SENT_ERROR');
                            });
                    })
                    .catch(err => logger.error(err));
            }
        };

        recruiterOpenJobCtrl.sendScrapeRequest = async function (email) {
            if (_.isArray(email.to) && email.to.length === 0) {
                return NotificationService.error('REQUEST_SCRAPPING_NOTIFICATION_MISSING_EMAIL_ADDRESS');
            }

            try {
                const subject = EmailService.cleanUpSpecificHTMLTags(email.subject || '');
                const body = email.content;
                const currentRecruiterData = recruiterOpenJobCtrl.recruiterCtrl.recruiterData;
                const from = EmailService.getEmailDataFromRecruiterData(currentRecruiterData);

                await Promise.all([
                    EmailService.sendEmail({
                        subject,
                        body,
                        from,
                        to: email.to,
                        bcc: [from.email],
                    }),
                    MessageService.addMessage({
                        subject,
                        body,
                        destinations: [],
                        source: { recruiterId: currentRecruiterData._id },
                        messageContext: { positionId: recruiterOpenJobCtrl.positionData._id },
                    }),
                    recruiterOpenJobCtrl.requestScrape(currentRecruiterData),
                ]);
            } catch (err) {
                logger.error(err);

                recruiterOpenJobCtrl.loading = false;
                recruiterOpenJobCtrl.notificationService.error('SCRAPE_REQUEST_ERROR');
            } finally {
                recruiterOpenJobCtrl.asideForm = 'default';
            }
        };

        recruiterOpenJobCtrl.initScrapeRequest = async function () {
            const isDisabled = true; // TFT-6897

            if (isDisabled) {
                return;
            }

            let language = RouteService.getUserPreference('uiLanguage');
            if (!language) {
                language = 'en-US';
            }

            try {
                const [{ result }, recruitersEmails] = await Promise.all([
                    RouteService.getEmailTemplates(language, SCRAPE_TEMPLATES_NAME),
                    RecruiterService.getAllRecruitersEmails(),
                ]);

                recruiterOpenJobCtrl.asideForm = 'sendScrape';

                if (result && result.templates) {
                    const completeScrapeTemplate = (result.templates || []).find(({ name }) => name === SCRAPE_REQUEST_TEMPLATE_NAME);
                    const templates = EmailService.changeTemplateTags(
                        [completeScrapeTemplate],
                        recruiterOpenJobCtrl.positionData,
                        recruiterOpenJobCtrl.recruiterCtrl.recruiterData,
                        recruiterOpenJobCtrl.positionData.employerData,
                    );
                    const emailsTo = (recruitersEmails || []).map(value => ({
                        value,
                        isSelected: false,
                        canRemove: true,
                    }));

                    recruiterOpenJobCtrl.sendScrapeRequestEmailData = {
                        templates,
                        emailsTo: [{
                            value: DOMAIN_CONFIG.DATA_ANALYST_EMAIL,
                            isSelected: true,
                            canRemove: false,
                        }, ...emailsTo],
                    };
                }

                $scope.$apply();
            } catch (error) {
                logger.error(error);
            }
        };
    }

    onCloseModal() {
        this.asideForm = 'default';
    }

    updateMenuButtonsState(position) {
        this.menuButtons = this.getMenuButtons(position);
    }

    initCloneJobData() {
        this.positionService.getPosition(this.positionId)
            .then((response) => {
                const positionData = response.result;

                this.employerService.getEmployer(positionData.employerId)
                    .then((response) => {
                        const employerData = response.result;
                        const jobPostfix = '(Clone)';
                        this.cloneJobData = this.cloneJobData || {};
                        this.cloneJobData.positionData = angular.copy(positionData);
                        this.cloneJobData.currentEmployerData = angular.copy(employerData);
                        this.cloneJobData.currentEmployerName = angular.copy(employerData.name);
                        this.cloneJobData.jobTitle = `${angular.copy(positionData.jobTitle)} ${jobPostfix}`;
                        this.cloneJobData.isCurrentEmployer = 'true';
                        this.cloneJobData.selectedEmployer = null;
                    })
                    .catch(err => logger.error(err));


                this.employerService.getEmployers()
                    .then((response) => {
                        this.cloneJobData = this.cloneJobData || {};
                        this.cloneJobData.employerList =
                            (response.result || [])
                                .filter((item) => {
                                    const { status: { current: currentStatus = '' } } = item;
                                    const result = (currentStatus === 'Active');
                                    return result;
                                })
                                .sort((left, right) => {
                                    const result = left.name.toUpperCase() >= right.name.toUpperCase();
                                    return result ? 1 : -1;
                                });
                    })
                    .catch(err => logger.error(err));
            })
            .catch(err => logger.error(err));
    }

    async initDashboardComment() {
        try {
            const response = await this.positionService.getPositionComment(this.positionId) || {};
            this.positionComment = response.result;
            this.dialogComment = this.positionComment;
        } catch (err) {
            logger.error(err);
        }
    }

    cloneJob() {
        this.openModalDialog(this);
    }

    showDashboardComment() {
        this.dialogComment = this.positionComment;
        this.openDashboardCommentModalDialog(this);
    }

    cancelJobClone() {
        this.positionService.cancelClonePosition(this.buildCloneJobData())
            .then(() => this.notificationService.success('JOB_CLONE_CANCELED_NOTIFICATION_SUCCESS'))
            .catch(() => this.notificationService.error('JOB_CLONE_CANCELED_NOTIFICATION_ERROR'));
        this.closeModalDialog();
    }

    buildCloneJobData() {
        const isCurrentEmployer = JSON.parse(this.cloneJobData.isCurrentEmployer);
        let selectedEmployer = this.cloneJobData.currentEmployerData;
        if (!isCurrentEmployer) {
            selectedEmployer = this.cloneJobData.selectedEmployer;
        }

        const positionData = angular.copy(this.cloneJobData.positionData);
        let { location } = positionData;
        if (selectedEmployer.locations && selectedEmployer.locations.length > 0) {
            ([location] = selectedEmployer.locations);
        }
        positionData.positionId = positionData._id;
        positionData._id = null;
        positionData.jobTitle = this.cloneJobData.jobTitle;
        positionData.employerData = angular.copy(selectedEmployer);
        positionData.feedbackOnCandidates = [];
        positionData.migrationCode = '';
        positionData.location = location;
        positionData.employerId = (selectedEmployer || {})._id;
        if (!isCurrentEmployer) {
            positionData.salary = {
                from: 0,
                to: 0,
            };
            positionData.placementFee = {
                unit: '%',
                sum: 0,
            };
            positionData.tipsForRecruiters = [];
            positionData.contact.email = [];
            positionData.contact.phone = [];
        }
        return positionData;
    }

    async editDashboardComment(form) {
        form.$setSubmitted(true);

        this.positionComment = angular.copy(this.dialogComment);

        try {
            const recruiterId = this.recruiterCtrl.recruiterData._id;
            const positionId = this.positionData._id;
            this.closeDashboardCommentModalDialog();
            this.startLoading();
            await this.positionService.putPositionComment(positionId, {
                recruiterId,
                comment: this.positionComment,
            });
            this.notificationService.success('DASHBOARD_COMMENT_SAVE_SUCCESS');
        } catch (err) {
            logger.error(err);
            this.notificationService.error('DASHBOARD_COMMENT_SAVE_ERROR');
            this.stopLoading();
        } finally {
            this.stopLoading();
        }
    }

    submitJobClone(form) {
        form.$setSubmitted(true);
        const isJobTitleInvalid = (form.$name.$invalid == true) ||
            (!this.cloneJobData.jobTitle);
        const [nameInput = { $invalid: true }] = form.$$controls.filter(control => control.$name == 'jobTitle');
        nameInput.$invalid = isJobTitleInvalid;

        const isCurrentEmployer = JSON.parse(this.cloneJobData.isCurrentEmployer);
        const isEmployerNotSelected = (form.$name.$invalid == true) ||
            ((this.cloneJobData.selectedEmployer == null) &&
                (!isCurrentEmployer));

        const [employerSelect = { $invalid: true }] = form.$$controls.filter(control => control.$name == 'selectedEmployer');
        employerSelect.$invalid = isEmployerNotSelected;

        if (isEmployerNotSelected || isJobTitleInvalid) {
            return false;
        }

        this.positionService.clonePosition(this.buildCloneJobData())
            .then((data) => {
                const positionId = data.result._id;
                const { employerId } = data.result;
                this.notificationService.success('JOB_CLONE_SAVE_SUCCESS');

                this.WebAppRouteService.goToViewJobPage({
                    employerId,
                    positionId,
                });
            })
            .catch((err) => {
                logger.error(err);
                this.notificationService.error('JOB_CLONE_SAVE_ERROR');
            });

        this.closeModalDialog();
    }

    openModalDialog(data) {
        this.modalDialogData = data;
        $('#recruiterModalDialog')
            .modal('show');
        this.modalDialog = true;
    }

    closeModalDialog() {
        window.onbeforeunload = null;
        this.modalDialogData = null;
        $('#recruiterModalDialog')
            .modal('hide');
        this.modalDialog = false;
    }

    openDashboardCommentModalDialog(data) {
        this.modalDialogData = data;
        $('#dashboardCommentModalDialog')
            .modal('show');
        this.modalDialog = true;
    }

    closeDashboardCommentModalDialog() {
        window.onbeforeunload = null;
        this.modalDialogData = null;
        $('#dashboardCommentModalDialog')
            .modal('hide');
        this.modalDialog = false;
    }

    generateInsights() {
        const anySelectedSearchCriteria = this.positionData.desiredCandidateProfile.selected.length;

        if (!anySelectedSearchCriteria) {
            this.notificationService.error('INSIGHT_GEN_ERROR_NO_SEARCH');
            return;
        }

        this.loading = true;

        return this.positionReportService.createPositionReport(this.positionData._id)
            .then(() => {
                const { $state } = this;

                $state.current.data.selectedTab = INSIGHT_TAB;

                this.notificationService.success('INSIGHT_GEN_SUCCESS');
                $state.go($state.current, { positionId: this.positionData._id }, { reload: true });
            })
            .catch((err) => {
                this.notificationService.error('INSIGHT_GEN_ERROR_NO_SEARCH');
                logger.error(err);
                this.loading = false;
            });
    }

    async requestScrape(currentRecruiterData) {
        this.loading = true;

        try {
            await this.positionEventsService.requestScrape(this.positionData, currentRecruiterData);

            this.notificationService.success('SCRAPE_REQUEST_SUCCESS');
            this.$state.go('recruiter.openPosition', { positionId: this.positionData._id }, { reload: true });
        } catch (error) {
            logger.error(error);
            this.notificationService.error('SCRAPE_REQUEST_ERROR');
        } finally {
            this.loading = false;
        }
    }

    async initCompleteJobDefinition() {
        const language = this.routeService.getUserPreference('uiLanguage') || 'en-US';
        const { employerData } = this.positionData;
        const employerEmails = _.get(employerData, 'contact.email', []).map(({ value }) => value);

        try {
            const { result } = await this.routeService.getEmailTemplates(language, COMPLETE_JOB_DEFINITION_TEMPLATES_NAME);

            if (result && result.templates) {
                this.asideForm = 'completeJobDefinition';
                this.sendCompleteJobDefinitionEmailData = {
                    templates: this.emailService.changeTemplateTags(
                        result.templates,
                        this.positionData,
                        this.recruiterCtrl.recruiterData,
                        this.positionData.employerData,
                    ),
                    emailsTo: (employerEmails || []).map(value => ({
                        value,
                        isSelected: false,
                        canRemove: true,
                    })),
                };
            }
        } catch (error) {
            logger.error(error);
        } finally {
            this.$scope.$apply();
        }
    }

    async sendCompleteJobDefinitionEmail(email) {
        if (_.isArray(email.to) && email.to.length === 0) {
            return this.notificationService.error('REQUEST_SCRAPPING_NOTIFICATION_MISSING_EMAIL_ADDRESS');
        }

        const subjectValue = (email.subject || '').trim();

        if (!subjectValue) {
            return this.notificationService.error('COMPLETE_JOB_CALIBRATION_REQUEST');
        }

        try {
            this.loading = true;

            const positionId = this.positionData._id;
            const recruiterId = this.recruiterCtrl.recruiterData._id;
            const employerId = this.positionData.employerData._id;
            const subject = this.emailService.cleanUpSpecificHTMLTags(email.subject || '');
            const body = email.content;
            const currentRecruiterData = this.recruiterCtrl.recruiterData;
            const from = this.emailService.getEmailDataFromRecruiterData(currentRecruiterData);
            const wizardEvents = (this.positionData.events || []).filter(({ flowType }) => flowType === POSITION_EVENT_FLOW_TYPES.positionWizard);

            if (wizardEvents.length === 0) {
                await this.positionEventService.addWizardCreateJobEvent(this.positionData, currentRecruiterData);
            }

            const [, { result: talenyaBot }] = await Promise.all([
                this.positionService.sendCalibrationRequest(positionId, {
                    emails: email.to,
                    employerId,
                    recruiterId,
                    emailObj: {
                        from: 'talentExperts',
                        host: `${this.EnvSettings.Auth0RedirectUrl}`,
                        body,
                        to: email.to,
                        bcc: [from.email],
                        subject,
                        talentExpertName: from.fullName,
                        talentExpertEmail: from.email,
                        talentExpertCellPhone: from.phone,
                    },
                }),
                this.recruiterService.getTalenyaBotRecruiter(),
            ]);

            await this.positionService.addRecruiterToPosition({ positionId, recruiterId: talenyaBot._id });

            this.notificationService.success('COMPLETE_JOB_DEFINITION_REQUEST_SUCCESS');
        } catch (err) {
            logger.error(err);

            this.notificationService.error('COMPLETE_JOB_DEFINITION_REQUEST_ERROR');
        } finally {
            this.loading = false;
            this.asideForm = 'default';
            this.$scope.$apply();
        }
    }

    setActionDisplay(actionText = '') {
        const displayActions = {
            GENERATE_INSIGHT: () => this.initInsightData(),
            SEND_INSIGHT_REPORT: () => this.initInsightData(),
            RE_SEND_INSIGHT_REPORT: () => this.initInsightData(),
        };

        const action = displayActions[actionText];
        if (action) {
            action();
        }
    }

    onActionButtonClick({ value, isLoading }) {
        if (!this.positionData || isLoading) {
            return;
        }

        this.actions[value]();
    }

    // todo write tests
    getMenuButtons(recruiterPosition) {
        if (!this.positionData) {
            return [];
        }

        const isClaimed = recruiterPosition && (recruiterPosition.status === 'Active' && recruiterPosition.reason === 'Claim');
        const [secondaryActions, callForActionText] = this.positionEventsService.getRecruiterCondition({
            ...this.positionData,
            recruiterStatus: isClaimed ? 'Claimed' : null,
        });

        if (!secondaryActions) {
            return [];
        }

        this.setActionDisplay(callForActionText);

        const menuButtons = [{ value: callForActionText }];

        menuButtons.push(...(secondaryActions || []).map(value => ({ value })));

        if (this.positionEventsService.isCompleteJobDefinitionRequestAvailable(this.positionData)) {
            menuButtons.push({ value: 'COMPLETE_JOB_DEFINITION' });
        }

        return menuButtons;
    }

    async openCandidatesPosition() {
        const {
            $state,
            positionId,
            RecruiterWorkflowStepResolver,
            recruiterCtrl: {
                recruiterData: {
                    _id: recruiterId,
                },
            },
        } = this;
        const workflowStep = await RecruiterWorkflowStepResolver.getWorkflowStep(positionId, recruiterId);

        $state.go('recruiter.candidatesJob', {
            positionId,
            scroll: 0,
            currCandidatePage: 1,
            candidate: null,
            workflowStep,
        }, { reload: true });
    }

    handleSelectedTab() {
        const { $state } = this;
        const selectedTab  = $state?.current?.data?.selectedTab;

        if (selectedTab === INSIGHT_TAB) {
            this.tabDisplay = 8;
        } else {
            this.tabDisplay = 1;
        }
    }

    onInsightChange(insightBlocks) {
        this.insightBlocks = insightBlocks;
    }

    getEmployerStatusToDisplay(status) {
        switch (status) {
            case this.EMPLOYER_WORKFLOW_STATUS.CONTACT:
                return 'CONTACT_EMPLOYER';
            case this.EMPLOYER_WORKFLOW_STATUS.REVIEWED:
                return 'CLAIMED_EMPLOYER';
            case this.EMPLOYER_WORKFLOW_STATUS.INTERVIEW_AND_ASSESSMENT:
                return 'INTERVIEW_AND_ASSESSMENT_EMPLOYER';
            case this.EMPLOYER_WORKFLOW_STATUS.HIRED:
                return 'HIRED_EMPLOYER';
            case this.EMPLOYER_WORKFLOW_STATUS.REJECT:
                return 'REJECT_EMPLOYER';
            default:
                return this.EMPLOYER_WORKFLOW_STATUS.NONE;
        }
    }

    isValidEmployerStatusToGoTo(workflow) {
        const employerStatus = _.get(workflow, 'employerStatus.current');
        const lastFeedback = _.findLast(
            this.positionData.feedbackOnCandidates,
            feedback => feedback.talentId === workflow.talentId,
        );
        const isGoodFeedback = _.get(lastFeedback, 'grades.[0].grade') === 1;
        return employerStatus !== this.EMPLOYER_WORKFLOW_STATUS.NONE || isGoodFeedback;
    }

    getEmployerStatusLabel(workflow) {
        const employerStatus = _.get(workflow, 'employerStatus.current');
        const lastFeedback = _.findLast(
            this.positionData.feedbackOnCandidates,
            feedback => feedback.talentId === workflow.talentId,
        );
        const isGoodFeedback = _.get(lastFeedback, 'grades.[0].grade') === 1;

        switch (employerStatus) {
            case this.EMPLOYER_WORKFLOW_STATUS.NONE:
                return isGoodFeedback ? 'CONTACT_EMPLOYER' : this.EMPLOYER_WORKFLOW_STATUS.NONE;
            case this.EMPLOYER_WORKFLOW_STATUS.REVIEWED:
                return 'CLAIMED_EMPLOYER';
            case this.EMPLOYER_WORKFLOW_STATUS.INTERVIEW_AND_ASSESSMENT:
                return 'INTERVIEW_AND_ASSESSMENT_EMPLOYER';
            case this.EMPLOYER_WORKFLOW_STATUS.HIRED:
                return 'HIRED_EMPLOYER';
            case this.EMPLOYER_WORKFLOW_STATUS.REJECTED:
                return 'REJECTED_EMPLOYER';
            default:
                break;
        }
    }

    copyPublicPositionLinkToClipboard() {
        this.clipboard.copyText(this.getPublicPositionPageUrl());
        const t = this.$filter('translate');

        this.NotificationService.success(t('TE_VIEW_SHARE_PUBLIC_COPY_ACTION'));
    }

    openPublicPositionPage() {
        return this.WebAppRouteService.goToPositionDescriptionPage({
            positionId: this.$stateParams.positionId,
        }, true);
    }

    getPublicPositionPageUrl() {
        return `${this.EnvSettings.WebAppUrl}/public/position-description/${this.$stateParams.positionId}`;
    }
}

export const RecruiterOpenJobControllerConfiguration = {
    template,
    require: {
        recruiterCtrl: '^recruiterComponent',
    },
    controller: RecruiterOpenJobController,
    controllerAs: 'recruiterOpenJobCtrl',
};

angular.module('TALENYA-FE').component('recruiterOpenJobComponent', RecruiterOpenJobControllerConfiguration);
